import { useDroppable } from "@dnd-kit/core";
import { useEffect, useRef } from "react";

interface Props {
  children: React.ReactNode;
  isDraggingOverCanvas: boolean;
  isEmpty: boolean;
  hasItems: boolean;
  itemCount: number;
}

export const CanvasDropArea = ({
  children,
  isDraggingOverCanvas,
  isEmpty,
  hasItems,
  itemCount,
}: Props) => {

  const canvasRef = useRef<HTMLDivElement | null>(null);

  const { setNodeRef } = useDroppable({
    id: "canvas",
    data: { type: "canvas" },
  });

  // ✅ Scroll parent container
  useEffect(() => {
    if (isDraggingOverCanvas && canvasRef.current) {
      const scrollContainer = canvasRef.current.closest(".overflow-y-auto");

      if (scrollContainer) {
        scrollContainer.scrollTo({
          top: scrollContainer.scrollHeight,
          behavior: "smooth",
        });
      }
    }
  }, [isDraggingOverCanvas, itemCount]);

  return (
    <div
      ref={(node) => {
        setNodeRef(node);
        canvasRef.current = node;
      }}
      className={`

        border-2 border-dashed rounded-lg p-4
        flex flex-col
        transition-colors
        bg-slate-50 dark:bg-slate-800
        border-slate-400
        ${hasItems ? "gap-4" : ""}

      `}
    >


      {children}

      {/* 🔵 DROP MESSAGE (EMPTY CANVAS) */}
      {/*{isEmpty && (*/}
      <div
        className={`
            flex items-center justify-center
             ${hasItems ? "h-32" : "h-40"}

            rounded-lg border-2 border-dashed
            transition-all
            ${isDraggingOverCanvas
            ? "border-blue-500 bg-blue-50 text-blue-600"
            : "border-slate-300 text-slate-500"
          }
          `}
      >
        <div className="flex items-center gap-2 text-sm font-medium">
          <span>
            {isDraggingOverCanvas
              ? "Release to drop widget here"
              : hasItems
                ? "Drag here to add more widgets"
                : "Drag widgets here"}
          </span>

          {/* 🔢 COUNT BADGE */}
          <div className="relative group">
            {/* 🔢 COUNT BADGE */}
            <span
              className={`
      px-2 py-0.5 rounded-full text-xs font-semibold
      border cursor-default
      transition-colors
      ${isDraggingOverCanvas
                  ? "bg-blue-100 text-blue-700 border-blue-300 dark:bg-blue-900 dark:text-blue-200 dark:border-blue-700"
                  : "bg-blue-100 text-blue-900 border-blue-100 dark:bg-slate-700 dark:text-slate-200 dark:border-slate-700"
                }
    `}
              tabIndex={0}
            >
              {itemCount}
            </span>

            {/* 🧾 TOOLTIP */}
            <div
              className="
      pointer-events-none
      absolute left-1/2 -top-9 -translate-x-1/2
      whitespace-nowrap
      rounded-md px-2 py-1 text-xs font-medium
      opacity-0 scale-95
      transition-all duration-200
      group-hover:opacity-100 group-hover:scale-100
      group-focus-within:opacity-100 group-focus-within:scale-100
      bg-slate-900 text-white
      dark:bg-slate-200 dark:text-slate-900
      shadow-lg
    "
            >
              Total widgets count

              {/* Tooltip Arrow */}
              <span
                className="
    absolute left-1/2 -bottom-1
    -translate-x-1/2
    h-2 w-2 rotate-45
    bg-slate-900 dark:bg-slate-200
  "
              />
            </div>
          </div>

        </div>


      </div>
      {isEmpty && (
        <p className="text-slate-500 text-center mt-8 text-sm">
          Drag widgets here to build the template
        </p>
      )}
      {/* //)} */}
    </div>
  );
};
